module.exports = __webpack_public_path__ + "static/img/cont60 (4).70c1b87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (4).jpg
// module id = Un/g
// module chunks = 0